<template>
  <div :class="bem()">
    <div class="global-wrapper">
      <div :class="bem('content')">
        <BaseCopy
          :class="bem('title')"
          size="h1"
        >
          Owner's Guide
        </BaseCopy>

        <NuxtPage :products="products" />
      </div>

      <div :class="bem('contact')">
        <BaseCopy
          size="h4"
          :class="bem('contact-copy')"
        >
          Didn't find an answer to your question?
        </BaseCopy>
        <VisionButton
          :class="bem('contact-button')"
          to="/support/contact-us"
          square
          button-text="Contact Us"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  getOwnersGuideProducts,
  type ProductsWithOwnersGuideArticlesResponse
} from '~/gql/ownersGuide.gql'

const bem = useBEM('OwnersManual')

const { $sentry, $product } = useNuxtApp()

const { data, error } = await useDatoQuery<ProductsWithOwnersGuideArticlesResponse>({
  query: getOwnersGuideProducts
})

if (error.value) {
  $sentry.captureException(error)
  throw createError({
    statusCode: error.value.statusCode,
    statusMessage: error.value.statusMessage,
  })
}

const baseSKUs = data.value.allBaseProducts.filter(
  (product) => product._allReferencingOwnersGuideArticlesMeta.count > 0
).map((product) => product.sku)

// Get customised products for all baseSKUs
const customisedProducts = await Promise.all(baseSKUs.map($product.getCustomisedProduct))

const products = customisedProducts.map((customisedProduct) => ({
  id: customisedProduct.product.id,
  baseSku: customisedProduct.product.sku,
  title: customisedProduct.product.name,
  sku: customisedProduct?.heroDesigns[0]?.customSKU || customisedProduct?.heroDesigns[0]?.sku
})).sort((a, b) => a.title.localeCompare(b.title))
</script>

<style lang="postcss">
.OwnersManual {
  @apply mb-lg;
}

.OwnersManual__title {
  @apply mt-md;
}

.OwnersManual__contact-copy {
  @apply mb-xxs;
}
</style>
